export const RQ_BRAND_IN_MANAGER_ASSIST_API = {
  url: 'managerAssists/brand-list/<%= divisionId  %>',
  method: 'GET',
  auth: true,
};

export const RQ_SALES_PERFORMANCE_API  = {
  url:'managerAssists/salesPerformance',
  method:'POST',
  auth:true,
};

export const RQ_BRAND_PERFORMANCE_API  = {
  url:'managerAssists/brandSalesPerformance',
  method:'POST',
  auth:true,
};

export const RQ_RCPA_VALUE_API  = {
  url:'managerAssists/rcpaValue',
  method:'POST',
  auth:true,
};

export const RQ_RXBER_NUMBER_API  = {
  url:'managerAssists/rxerNumber',
  method:'POST',
  auth:true,
};

export const RQ_RCPA_VALUE_LINK_API  = {
  url:'managerAssists/rcpaLinkDetail',
  method:'POST',
  auth:true,
};

export const RQ_RCPA_TREND_VALUE_API  = {
  url:'managerAssists/rcpaTrendDashboard',
  method:'POST',
  auth:true,
};

export const RQ_RCPA_TREND_VALUE_LINK_API  = {
  url:'managerAssists/rcpaTrendLinkDetails',
  method:'POST',
  auth:true,
};

export const RQ_FIELD_WORKING_API  = {
  url:'managerAssists/field-working',
  method:'POST',
  auth:true,
};

export const RQ_COVERAGE_DATA_API  = {
  url:'managerAssists/coverage-data',
  method:'POST',
  auth:true,
};

export const RQ_MISSED_CALL_API  = {
  url:'managerAssists/missed-call',
  method:'POST',
  auth:true,
};

export const RQ_MISSED_CALL_FREQUENCY_API  = {
  url:'managerAssists/missed-call_by_frequency',
  method:'POST',
  auth:true,
};

export const RQ_MISSED_CALL_FREQUENCY_DETAILS_API  = {
  url:'managerAssists/missed-by-frequency-details',
  method:'POST',
  auth:true,
};

export const RQ_TOUR_PLAN_DEVIATION_API  = {
  url:'managerAssists/tour_plan_deviation',
  method:'POST',
  auth:true,
};

export const RQ_TOUR_PLAN_DEVIATION_DETAILS_API  = {
  url:'managerAssists/tour-plan-deviation-details',
  method:'POST',
  auth:true,
};

export const RQ_ATTRITION_API = {
  url: 'managerAssists/attrition/<%= locationId  %>',
  method: 'POST',
  auth: true,
  search: false,
};

export const RQ_ATTRITION_DETAILS_LINK_API  = {
  url:'managerAssists/attrition-detail/<%= locationId  %>/<%= yyyyMm  %>/<%= jobRole  %>',
  method:'POST',
  auth:true,
};

export const RQ_COVERAGE_DETAILS_LINK_API  = {
  url:'managerAssists/coverage-detail',
  method:'POST',
  auth:true,
};

export const RQ_FIELD_DETAILS_LINK_API  = {
  url:'managerAssists/field-working-detail',
  method:'POST',
  auth:true,
};

export const RQ_MISSED_CALL_DETAILS_LINK_API  = {
  url:'managerAssists/missed-call-details',
  method:'POST',
  auth:true,
};

export const RQ_UPWARD_SHIFT_API  = {
  url:'managerAssists/upward-shift-doctors/<%= locationId  %>',
  method:'POST',
  auth:true,
};

export const RQ_SHIFT_DETAILS_LINK_API  = {
  url:'managerAssists/doctor-shift-details',
  method:'POST',
  auth:true,
};

export const RQ_DOWNWARD_SHIFT_API  = {
  url:'managerAssists/downward-shift-doctors/<%= locationId  %>',
  method:'POST',
  auth:true,
};

export const RQ_SAMPLE_API  = {
  url:'managerAssists/sample-dashboard/<%= locationId  %>',
  method:'POST',
  auth:true,
};

export const RQ_SAMPLE_DETAIL_API  = {
  url:'managerAssists/sample-details',
  method:'POST',
  auth:true,
};

export const RQ_DEACTIVE_DOCTORS_API  = {
  url:'managerAssists/deactivated-doctors',
  method:'POST',
  auth:true,
};

export const RQ_DEACTIVE_DOCTORS_DETAILS_API  = {
  url:'managerAssists/deactivated-doctor-details',
  method:'POST',
  auth:true,
};

export const RQ_ACTIVE_DOCTORS_API  = {
  url:'managerAssists/activity-data',
  method:'POST',
  auth:true,
};

export const RQ_ACTIVE_DOCTORS_DETAILS_API  = {
  url:'managerAssists/activity-data-details',
  method:'POST',
  auth:true,
};

export const RQ_GLIMADAY_REPORT_API = {
  url: 'managerAssists/glimaday-data-report/<%= locationId  %>/<%= yearMonth  %>',
  method: 'GET',
  auth: true,
};

export const RQ_GLIMADAY_DOCTOR_REPORT_API = {
  url: 'managerAssists/glimaday-doctor-report/<%= locationId  %>/<%= yearMonth  %>',
  method: 'GET',
  auth: true,
};
